'use client';

import { persistSelectItemData } from '../itemSelectionUtils';
import type { RelewiseProduct } from '~/components/features';
import type { ItemListType, SelectItemEvent } from '../types';
import { sendGTMEvent } from 'tracking';
import { relewiseProductToGAItem } from '../productMappers/relewiseProductToGAItem';

export type Props = {
  product: RelewiseProduct;
  itemListName?: string;
  itemListId?: string;
  itemListType?: ItemListType;
  index?: number;
};

export function trackSelectItem({ product, itemListName, itemListId, itemListType, index }: Props) {
  const eventData: SelectItemEvent = {
    event: 'select_item',
    ecommerce: {
      items: [relewiseProductToGAItem(product, {
        index,
        listId: itemListId,
        listName: itemListName?.toLowerCase(),
        listType: itemListType
      })],
    },
  };

  sendGTMEvent(eventData);
  persistSelectItemData(eventData);
}
